import script from "./ShootingListTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShootingListTab.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__